// IMPORTS
// Modules
import { useState, useEffect } from 'react';
import $ from 'jquery';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../../../onehivesystems/js/OHSApp';
import OHSWidget from '../../../../onehivesystems/js/OHSWidget';
import OHSFilter from '../../../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormDataExtractor, OHSFormDataClearer } from '../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../onehivesystems/js/OHSCRUD';
// Assets
import './Fields.scss';
import { fieldModel } from './_variables';
import Field from './Modules/Field';
import FieldTypes from './Modules/FieldTypes';


// COMPONENT
export default function Fields (props) {
   // States and Variables
   const [fields, setFields] = useState(null);
   const [optionsField, setOptionsField] = useState(false);
   const [fieldPopups, setFieldPopups] = useState({});

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("OnePort | Fields"); // set page title
      getFields();
   }, []);

   // Functions
   const getFields = function () {
      OHSCRUD({
         url: '/v1/oneport/fields',
         method: 'GET',
         success: function (data) {
            setFields(OHSListDataFormatter(data, fieldModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }
   const addField = function () {
      OHSCRUD({
         url: '/v1/oneport/fields',
         method: 'POST',
         payload: OHSFormDataExtractor('oneport-fields-add'),
         success: function (data) {
            if (fields.length > 0) {
               setFields([...fields, OHSListDataFormatter(data[0], fieldModel)]);
            } else {
               setFields([OHSListDataFormatter(data[0], fieldModel)]);
            }
            OHSFormDataClearer('oneport-fields-add');
            toggleOptionsField(); // used to hide the options field after reload
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const reorderFields = function (order) {
      OHSCRUD({
         url: '/v1/oneport/fields/reorder',
         method: 'PUT',
         payload: order,
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      })
   }
   const toggleOptionsField = function () {
      if ($('#oneport-fields-add-type').val() == "select") {
         setOptionsField(true);
      } else {
         setOptionsField(false);
      }
   }

   // Component
   return (
      <div className="oneport-fields">
         <OHSAppHeader onehive={props.onehive} title="Fields" help="https://www.onehivesystems.com/documentation/oneport/fields" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} id='oneport-fields-add' title="Add a Field" onEnter={addField}>
               <OHSFormItem onehive={props.onehive} title="Name">
                  <input type='text' className='ohsinput' data-ohsformdata='name' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Type">
                  <select id='oneport-fields-add-type' className='ohsinput' data-ohsformdata='type' onChange={toggleOptionsField}>
                     <FieldTypes onehive={props.onehive} />
                  </select>
               </OHSFormItem>
               {optionsField && 
                  <OHSFormItem onehive={props.onehive} title="Options">
                     <textarea className='ohsinput' data-ohsformdata='options' placeholder='Enter one option per line' />
                  </OHSFormItem>
               }
               <OHSFormItem onehive={props.onehive} title="Required?">
                  <input type='checkbox' className='ohsinput' data-ohsformdata='required' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Use for Availability?">
                  <input type='checkbox' className='ohsinput' data-ohsformdata='use_for_availability' />
               </OHSFormItem>
               <OHSFormItem onehive={props.onehive} title="Value in List?">
                  <input type='checkbox' className='ohsinput' data-ohsformdata='value_in_list' />
               </OHSFormItem>
               <OHSFormSubmit onehive={props.onehive} add={addField} clear={() => {OHSFormDataClearer('oneport-fields-add');}} keyListener={true} />
            </OHSWidget>
            <OHSFilter onehive={props.onehive} title="Filter Fields" container='oneport-fields-list' />
            <OHSWidget onehive={props.onehive} id='oneport-fields-list' title="List of Fields">
               <OHSList onehive={props.onehive} content={fields} popups={fieldPopups} setPopups={setFieldPopups} enableDragging={true} handleDragging={reorderFields} template={
                  <Field onehive={props.onehive} parent={{
                     fields: fields,
                     setFields: setFields
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}